import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ValidatePanResponse, BindRequest, UpdateRequest, BlockRequest } from '../models/physical-card';
import { ResponseBase } from '../models/response-base';

@Injectable({
  providedIn: 'root'
})
export class PhysicalCardService {

    private URL = environment.GATEWAY + 'physicalCard/';

    constructor(private http: HttpClient) { }

    validatePan(pan: string): Observable<ResponseBase<ValidatePanResponse>> {
        return this.http.post<ResponseBase<ValidatePanResponse>>(`${this.URL}validate/${pan}`, null);
    }

    bindCard(bindRequest: BindRequest): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}bind`, bindRequest);
    }

    changeCardPassword(updateRequest: UpdateRequest): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}pin/update`, updateRequest);
    }

    blockDefinitive(blockRequest: BlockRequest, justifyCode: number): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}block/definitive/${justifyCode}`, blockRequest);
    }

    blockTemporary(blockRequest: BlockRequest): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}block/temporary`, blockRequest);
    }

    unblockTemporary(blockRequest: BlockRequest): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}unblock/temporary`, blockRequest);
    }

    /* legal person (pj) */

    bindCardLegalPerson(bindRequest: BindRequest): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}pj/bind`, bindRequest);
    }

    changeCardPasswordLegalPerson(updateRequest: UpdateRequest): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}pj/pin/update`, updateRequest);
    }

    blockDefinitiveLegalPerson(blockRequest: BlockRequest, justifyCode: number): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}pj/block/definitive/${justifyCode}`, blockRequest);
    }

    blockTemporaryLegalPerson(blockRequest: BlockRequest): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}pj/block/temporary`, blockRequest);
    }

    unblockTemporaryLegalPerson(blockRequest: BlockRequest): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${this.URL}pj/unblock/temporary`, blockRequest);
    }
}
